import { render, staticRenderFns } from "./InviteForm.vue?vue&type=template&id=72e4f256&"
import script from "./InviteForm.vue?vue&type=script&lang=ts&"
export * from "./InviteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports